import { render, staticRenderFns } from "./QueuePlate.vue?vue&type=template&id=f45620e0&scoped=true&"
import script from "./QueuePlate.vue?vue&type=script&lang=ts&"
export * from "./QueuePlate.vue?vue&type=script&lang=ts&"
import style0 from "./QueuePlate.vue?vue&type=style&index=0&id=f45620e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45620e0",
  null
  
)

export default component.exports